import React, { useMemo } from 'react';
import { QAlert, QStack } from '@qualio/ui-components';
import EventFormField from '../EventFormField/EventFormField';
import * as DisplayStrings from '../../displayStrings';
import { ViewModeDictionary } from '../EventFormField/EventFormField.types';
import { FormTemplateField, NewFormTemplateField } from '../../types/formFields/formTemplates';
import { FieldTypeSchema } from '../../types/formFields/common';
type FieldForDisplay = {
  uniqueId: string | number;
  id?: FormTemplateField['id'];
} & (FormTemplateField | NewFormTemplateField);

type EventFormProps = {
  formFields: FieldForDisplay[];
};

const EventFormPreview: React.FC<EventFormProps> = ({ formFields }) => {
  const duplicateLabels = useMemo(() => {
    const labels = (formFields ?? []).map((field) => field.label);
    return labels.filter((item, index) => labels.indexOf(item) !== index);
  }, [formFields]);

  return (
    <QStack direction="column" spacing="20px">
      <QAlert status="info" description={DisplayStrings.FormPreviewWarning} />
      {duplicateLabels.length > 0 && (
        <QAlert status="warning" description={DisplayStrings.FormPreviewDuplicateLabelWarning} />
      )}
      <QStack direction="column" spacing="30px">
        {formFields.map((formField) => {
          const showAlertIcon = duplicateLabels.includes(formField.label);
          return (
            <EventFormField
              key={formField.id ?? formField.uniqueId}
              data-cy={`${formField.type}-${formField.id ?? formField.uniqueId}`}
              mode={ViewModeDictionary.PREVIEW}
              defaultContent={formField.default_content ?? ''}
              inputType={formField.type}
              helper={formField.helptext ?? undefined}
              label={formField.label}
              isRequired={formField.mandatory}
              multi={formField.multi}
              resourceSubType={formField.resource_sub_type}
              showAlertIcon={showAlertIcon}
              options={
                formField.type === FieldTypeSchema.enum.dropdown ||
                formField.type === FieldTypeSchema.enum.checkbox ||
                formField.type === FieldTypeSchema.enum.radio
                  ? formField.form_option_list.options.map(({ value }) => value)
                  : undefined
              }
            />
          );
        })}
      </QStack>
    </QStack>
  );
};

export default EventFormPreview;
